const fr = {
  // Hero Section
  hero: {
    title: "Votre Compagnon",
    titleHighlight: "Médical",
    subtitle: "Intelligent",
    description:
      "Rationalisez la gestion des patients, les rendez-vous et les dossiers médicaux avec le tableau de bord de santé complet de RAQIB.",
    buttonGetStarted: "Commencer",
    buttonWatchDemo: "Regarder la démo",
  },

  // Features Section
  features: {
    sectionTitle: "Gestion complète de la santé",
    sectionDescription:
      "RAQIB vous fournit tous les outils nécessaires pour gérer efficacement votre pratique médicale et offrir des soins exceptionnels aux patients.",
    items: [
      {
        emoji: "👨‍⚕️",
        title: "Gestion des patients",
        description:
          "Profils complets des patients avec antécédents médicaux, allergies, médicaments et plans de traitement au même endroit.",
      },
      {
        emoji: "📅",
        title: "Planification intelligente",
        description:
          "Système de rendez-vous intuitif avec rappels automatisés pour réduire les absences et optimiser votre calendrier.",
      },
      {
        emoji: "💊",
        title: "Gestion des prescriptions",
        description:
          "Créez, suivez et gérez les ordonnances numériquement avec l'intégration aux pharmacies.",
      },
      {
        emoji: "📊",
        title: "Analyses médicales",
        description:
          "Analyses puissantes pour suivre les résultats des patients, les performances cliniques et les mesures financières.",
      },
      {
        emoji: "💳",
        title: "Facturation et assurance",
        description:
          "Processus de facturation rationalisé avec support des sinistres d'assurance et suivi des paiements.",
      },
      {
        emoji: "🛡️",
        title: "Conforme HIPAA",
        description:
          "Sécurité et conformité de niveau entreprise pour protéger les informations de santé sensibles des patients.",
      },
    ],
  },

  // Demo Video Section
  demoVideo: {
    title: "Voir RAQIB en action",
    description:
      "Regardez notre démo de 2 minutes pour voir comment RAQIB peut transformer la gestion de votre pratique médicale.",
    benefits: [
      "Réduisez la charge administrative de 60%",
      "Améliorer la satisfaction des patients avec une expérience transparente",
      "Accéder aux données critiques des patients n'importe quand, n'importe où",
    ],
    videoDemoTitle: "Démo de la plateforme RAQIB",
  },

  // Testimonials Section
  testimonials: {
    sectionTitle: "Approuvé par les professionnels de la santé",
    items: [
      {
        initials: "DR",
        name: "Dr. Sarah Johnson",
        title: "Cardiologue, City Hospital",
        text: "RAQIB a transformé la manière dont nous gérons les soins aux patients. L'interface intuitive nous fait gagner des heures chaque semaine, ce qui nous permet de nous concentrer sur ce qui compte vraiment - nos patients.",
        rating: 5,
      },
      {
        initials: "NP",
        name: "Infirmière Priya Patel",
        title: "Praticienne infirmière",
        text: "Le suivi des médicaments et les fonctionnalités de prescription changent la donne. Je peux maintenant gérer tous les médicaments de mes patients sans me soucier des erreurs.",
        rating: 5,
      },
      {
        initials: "AM",
        name: "Alex Morgan",
        title: "Administrateur clinique",
        text: "Notre processus de facturation prenait des jours. Avec RAQIB, nous le complétions en heures. Les fonctionnalités de rapports nous aident à prendre des décisions basées sur les données pour notre pratique.",
        rating: 4,
      },
    ],
  },

 

  // Pricing Section
  pricing: {
    sectionTitle: "Tarification simple et transparente",
    description:
      "Choisissez le plan qui convient aux besoins de votre pratique. Pas de frais cachés, annulez à tout moment.",
  },

  // CTA Section
  cta: {
    title: "Prêt à transformer votre pratique médicale?",
    description:
      "Rejoignez des milliers de professionnels de la santé qui font confiance à RAQIB pour leurs besoins de gestion de pratique.",
    buttonStartTrial: "Démarrer l'essai gratuit",
    buttonScheduleDemo: "Planifier une démo",
  },
};

export default fr;
